import common from './common';
import sga from './sga';

const configs = { sga };

export default { configs, common };
